/* eslint-disable prettier/prettier */
import { createContext } from 'react';
import { TrackingEventsEnum } from 'types/trackingAnalytics';

export interface ITrackingAnalyticsContext {
    trackEvent(event: TrackingEventsEnum, details?: { [propName: string]: string | number }): void;
}

export const TrackingAnalyticsContext = createContext<ITrackingAnalyticsContext | null>(null);
export const TrackingAnalyticsConsumer = TrackingAnalyticsContext.Consumer;